export default {
      id: "3-1-usage",
      viewBox: "0 0 88 88",
      url: "assets/" + "sprite.svg#3-1-usage",
      toString: function () {
        return this.url;
      }
    }